module.exports = __webpack_public_path__ + "img/magenta-logo.93d42fb0.svg";